import { z } from 'zod';
import { Module } from './roles.js';

export const UsageBucket = z.object({
  date: z.string(),
  module: Module,
  totalRendered: z.number().int().nonnegative(),
  servedFromCash: z.number().int().nonnegative(),
  totalHits: z.number().int().nonnegative(),
  extraRenders: z.number().int().nonnegative(),
  extraHits: z.number().int().nonnegative(),
  extraCost: z.number().nullable().optional(),
});
export type UsageBucket = z.infer<typeof UsageBucket>;

export const UsageResponse = z.object({
  workspace_id: z.string(),
  from: z.string(),
  to: z.string(),
  buckets: z.array(UsageBucket),
  totals: z.object({
    totalRendered: z.number().int().nonnegative(),
    servedFromCash: z.number().int().nonnegative(),
    totalHits: z.number().int().nonnegative(),
    extraRenders: z.number().int().nonnegative(),
    extraHits: z.number().int().nonnegative(),
    cache_hit_ratio: z.number().min(0).max(1),
  }),
});
export type UsageResponse = z.infer<typeof UsageResponse>;
